import { formatCurrencyAmount, getStruckThroughCatalogPrice, type MoneyWithOptionalCurrency } from 'noddi-util';

export type PayableTextProps = {
  payable: MoneyWithOptionalCurrency;
  original?: MoneyWithOptionalCurrency | null;
  decimals?: 0 | 2;
  freeLabel?: string;
  hideWhenZero?: boolean;
};

/** The payable text `CatalogPrice` shows, or null when it renders nothing. Accessible names reuse it. */
export const getCatalogPayableText = ({
  payable,
  original,
  decimals = 0,
  freeLabel,
  hideWhenZero
}: PayableTextProps): string | null => {
  if (hideWhenZero && payable.amount === 0 && getStruckThroughCatalogPrice({ payable, original }) == null) {
    return null;
  }
  return payable.amount === 0 && freeLabel != null ? freeLabel : formatCurrencyAmount({ money: payable, decimals });
};
